/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { date, DateFormat, entity, enumeration } from '@gh/core-data';
import {
  BulkUpdateComponentAddDto,
  BulkUpdateComponentDeleteDto,
  BulkUpdateComponentReplaceDto,
  BulkUpdateHousePlanAddDto,
  BulkUpdateHousePlanDeleteDto,
  BulkUpdateHousePlanReplaceDto,
  BulkUpdateItemComponentListItemDto,
  BulkUpdateReplaceInitDto,
  BulkUpdateTaskStatus,
  ButlListItemDto,
} from './bulk-update.dto';

export const BulkUpdateHousePlanAddMapper = entity<BulkUpdateHousePlanAddDto>();
export const BulkUpdateComponentAddMapper = entity<BulkUpdateComponentAddDto>();
export const BulkUpdateItemComponentListItemMapper = entity<BulkUpdateItemComponentListItemDto>();
export const BulkUpdateHousePlanReplaceMapper = entity<BulkUpdateHousePlanReplaceDto>();
export const BulkUpdateComponentReplaceMapper = entity<BulkUpdateComponentReplaceDto>();
export const BulkUpdateHousePlanDeleteMapper = entity<BulkUpdateHousePlanDeleteDto>();
export const BulkUpdateComponentDeleteMapper = entity<BulkUpdateComponentDeleteDto>();
export const BulkUpdateReplaceInitMapper = entity<BulkUpdateReplaceInitDto>();

export const ButlListItemMapper = entity<ButlListItemDto>({
  addedDate: date(DateFormat.DateTime),
  updatedDate: date(DateFormat.DateTime),
  statusValue: enumeration(BulkUpdateTaskStatus),
});
